export default function SteamChartLegend({ games, chartGames, highlighted, colorForIndex, onToggle, onRemove }) {
  const selected = Array.isArray(highlighted) ? highlighted : highlighted ? [String(highlighted)] : [];
  return <div className="steam-chart-legend" aria-label="Chart legend">
    {games.map(({ game, peak }, rank) => {
      const id = String(game.metadata.app_id);
      const index = chartGames.findIndex(row => String(row.metadata.app_id) === id);
      const active = selected.includes(id);
      return <div key={id} className={`steam-chart-legend-item${selected.length && !active ? " is-dimmed" : ""}`}
        style={{ "--series-color": colorForIndex(index) }}>
        <button type="button" className="steam-chart-legend-select" aria-pressed={active}
          aria-label={`Highlight ${game.metadata.name}`} onClick={event => onToggle(id, event.ctrlKey || event.metaKey)}>
          <span className="steam-chart-legend-art">
            <img src={game.metadata.box_art} alt="" />
            <span>#{rank + 1}</span>
          </span>
          <span className="steam-chart-legend-text"><strong>{game.metadata.name}</strong>
            <small>Peak {Number(peak || 0).toLocaleString()}</small></span>
        </button>
        <button type="button" className="steam-chart-legend-remove" aria-label={`Remove ${game.metadata.name} from chart`}
          onClick={() => onRemove(id)}>×</button>
      </div>;
    })}
  </div>;
}
